import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import ButtonBase from '@mui/material/ButtonBase';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import { isC2RTransaction } from 'data/transactions/utils';
import QTip from 'components/QuickenControls/QTip';
import QTypography from 'components/MUIWrappers/QTypography';
import AccountsMenu from 'components/QuickenControls/AccountsMenu';

import { getAccountString } from 'data/accounts/retrievers';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface AccountFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  wrapClass: string;
  showAccountColors: boolean;
  accountColorForId: string;
  accountMenuEl: any;
  updateAccountMenuEl: (menuEl: any) => void;
  editable: boolean;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
  bankPendingClass: string;
}

const AccountField: FC<AccountFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  SHOW_ALL,
  fieldActive,
  txn,
  wrapClass,
  showAccountColors,
  accountColorForId,
  accountMenuEl,
  updateAccountMenuEl,
  editable,
  focusField,
  bankPendingClass,
}) => {

  const { classes } = useStyles();

  const flexClass = showAccountColors ? 'none' : 'flex1 protectWidth';
  const regClass = showAccountColors ? '' : classes.regItem;
  const acctName = getAccountString(txn.accountId);
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';

  const renderCore = () => (
    <>
      {showAccountColors &&
        <div
          className={classes.accountFieldColor}
        >
          <div
            className={classes.accountColorDiv}
            style={{ background: accountColorForId }}
          >
          </div>
        </div>}

      {!showAccountColors &&
        <div
          className={classNames(classes.accountFieldName, bankPendingClass, c2RTxnClass)}
        >
          <QTip
            title={acctName}
            // @ts-expect-error: Property 'distance' does not exist
            distance={3}
            wrapOnly
            position="bottom"
            wrapId={`${txn.id}-account`}
          >
            <QTypography
              thinFont
              clickable
              className={classes.regItemCore}
            >
              {acctName}
            </QTypography>
          </QTip>
        </div>}
    </>
  );

  return (
    <RegListItem
      {...attributes}
      className={classNames(fieldActive && 'editable', regClass, flexClass, fieldActive ? 'wraptext' : wrapClass)}
      tabIndex="0"
    >
      {SHOW_ALL &&
        <>
          {editable &&
          // @ts-expect-error: missing props
          <ButtonBase
            id={`${showAccountColors ? 'AcctColorMenu' : 'AcctMenu'}${txn.id}`}
            aria-label="Account Menu"
            classes={{ root: classes.buttonRoot }}
            focusRipple
            autoFocus
            disabled={forceStatic}
            ref={fieldActive ? (input) => {
              focusField.current = input; // eslint-disable-line
            } : null}
            onClick={fieldActive ? (e) =>
              updateAccountMenuEl(e.currentTarget) : null}
          >
            {renderCore()}
          </ButtonBase>}

          {!editable && renderCore()}

          {editable && fieldActive && accountMenuEl && (
            <AccountsMenu
              element={accountMenuEl}
              selected={txn.accountId!}
              showColors={showAccountColors}
              onChange={(event) => {
                updateAccountMenuEl(null);
                callbacks.handleChange?.(event, 'account');
              }}
              onClose={() => {
                updateAccountMenuEl(null);
                setTimeout(() => callbacks.resetFocus?.(), 100);
              }}
            />
          )}
        </>}
    </RegListItem>
  );
};

export default AccountField;
